import { $api } from "@/lib/api-client";

interface MutationOptions {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

export const useAddFavorite = (options?: MutationOptions) =>
  $api.useMutation("post", "/favorites/product/{productId}", {
    onSuccess: () => options?.onSuccess?.(),
    onError: (error) => options?.onError?.(error),
  });

export const useRemoveFavorite = (options?: MutationOptions) =>
  $api.useMutation("delete", "/favorites/product/{productId}", {
    onSuccess: () => options?.onSuccess?.(),
    onError: (error) => options?.onError?.(error),
  });
